module.exports = __webpack_public_path__ + "img/avatar_agent_woman.6d73341a.jpg";